import React from "react";

const ComparisonRow = ({label, property, products, valueFormatter, labelFormatter}) => {
    const getPropertyOrDefault = (product, property, defaultValue) => {
        if(product.hasOwnProperty(property) && product[property]) {
            if(valueFormatter) {
                return valueFormatter(product)
            } else {
                return product[property].value;
            }
        } else {
            return defaultValue;
        }
    }

    const getLabel = (products, property, labelFormatter) => {
        const product = products[0];
        if(labelFormatter) {
            return labelFormatter(product)
        } else {
            return product[property].label
        }
    }

    return (
        <div className="row">
            <div className="property-label">{getLabel(products, property, labelFormatter)}</div>
            {products.map(product => (
                <div key={product.id} className={"property-value" + (product.inCart ? " in-cart": "")}>
                    {getPropertyOrDefault(product, property, "-", valueFormatter)}
                </div>
            ))}
        </div>
    )
}

export default ComparisonRow;